import { NgModule } from '@angular/core';

import { SideMenuComponent } from './side-menu.component';

/**
 * Compatibility shell: SideMenuComponent is standalone, this module only re exports it for
 * the NgModule based page apps. Import the component directly in standalone contexts.
 */
@NgModule({
    imports: [SideMenuComponent],
    exports: [SideMenuComponent],
})
export class SideMenuModule {}
